enum HOUSING_TYPES {
  APARTMENT = 'Apartment',
  HOUSE = 'House',
  OTHER = 'Other',
  UNKNOWN = 'Unknown',
}

export default HOUSING_TYPES;
